module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead14-65db324ed7f6afef137002e315eafc6c.jpg";